// src/views/Lotes/FiltroLotes.jsx
import React, { useEffect, useRef, useState } from "react";
import apiRoutes from "../../../api/apiRoutes";
import { apiFetchJson } from "../../../utils/http";

export default function FiltroLotes({
  initial = {}, // { idLote, estado, fechaDesde, fechaHasta }
  onSubmit = () => {}, // (snapshot) => void
  onClose = () => {}, // () => void
}) {
  const panelRef = useRef(null);

  // Campos
  const [idLote, setIdLote] = useState(initial.idLote ?? "");
  const [estado, setEstado] = useState(initial.estado ?? "");
  const [fechaDesde, setFechaDesde] = useState(initial.fechaDesde ?? "");
  const [fechaHasta, setFechaHasta] = useState(initial.fechaHasta ?? "");

  // Estados (opciones)
  const [estados, setEstados] = useState([
    { id: "", label: "Todos" },
    { id: "LOTE ABIERTO", label: "LOTE ABIERTO" },
    { id: "LOTE CERRADO", label: "LOTE CERRADO" },
  ]);

  // Rehidratación si cambian los iniciales
  useEffect(() => {
    setIdLote(initial.idLote ?? "");
    setEstado(initial.estado ?? "");
    setFechaDesde(initial.fechaDesde ?? "");
    setFechaHasta(initial.fechaHasta ?? "");
  }, [initial]);

  // Cerrar al click fuera
  useEffect(() => {
    const onDocClick = (e) => {
      if (panelRef.current && !panelRef.current.contains(e.target)) onClose();
    };
    document.addEventListener("mousedown", onDocClick);
    return () => document.removeEventListener("mousedown", onDocClick);
  }, [onClose]);

  // Cerrar con ESC
  useEffect(() => {
    const onEsc = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", onEsc);
    return () => window.removeEventListener("keydown", onEsc);
  }, [onClose]);

  // Cargar opciones de estado si existe endpoint (opcional)
  useEffect(() => {
    const url = apiRoutes?.lotes?.estados;
    if (!url) return;
    (async () => {
      try {
        const data = await apiFetchJson(url);
        if (Array.isArray(data) && data.length) {
          const opts = [{ id: "", label: "Todos" }].concat(
            data.map((e) => ({
              id: String(e.id ?? e.value ?? e).toUpperCase(),
              label: String(e.nombre ?? e.label ?? e),
            })),
          );
          setEstados(opts);
        }
      } catch {
        /* fallback al set inicial */
      }
    })();
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();

    // Normalizamos rango de fechas si vienen invertidas
    let d1 = fechaDesde;
    let d2 = fechaHasta;
    if (d1 && d2 && new Date(d1) > new Date(d2)) {
      [d1, d2] = [d2, d1];
    }

    onSubmit({
      idLote: (idLote || "").trim(),
      estado,
      fechaDesde: d1 || "",
      fechaHasta: d2 || "",
    });
  };

  return (
    <div className="drawer-backdrop">
      <div
        ref={panelRef}
        className="drawer-panel overflow-auto"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="drawer-header">
          <h2 className="text-title">Filtros</h2>
          <button onClick={onClose} className="btn-cancel" title="Cerrar">
            &times;
          </button>
        </div>

        {/* Body */}
        <form onSubmit={handleSubmit} className="drawer-body">
          {/* Id Lote */}
          <div>
            <label htmlFor="idLote" className="form-label-fil">
              Id Lote
            </label>
            <input
              id="idLote"
              className="input"
              value={idLote}
              onChange={(e) => setIdLote(e.target.value)}
              placeholder="Ej.: 2973"
              autoComplete="off"
            />
          </div>

          {/* Estado */}
          <div>
            <label htmlFor="estado" className="form-label-fil">
              Estado
            </label>
            <select
              id="estado"
              className="input"
              value={estado}
              onChange={(e) => setEstado(e.target.value)}
            >
              {estados.map((op) => (
                <option key={op.id} value={op.id}>
                  {op.label}
                </option>
              ))}
            </select>
          </div>

          {/* Fechas */}
          <div>
            <label className="form-label-fil">Fecha (rango)</label>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
              <div>
                <input
                  type="datetime-local"
                  className="input"
                  value={fechaDesde}
                  onChange={(e) => setFechaDesde(e.target.value)}
                />
                <div className="text-xs text-gray-600 mt-1">Desde</div>
              </div>
              <div>
                <input
                  type="datetime-local"
                  className="input"
                  value={fechaHasta}
                  onChange={(e) => setFechaHasta(e.target.value)}
                />
                <div className="text-xs text-gray-600 mt-1">Hasta</div>
              </div>
            </div>
          </div>

          {/* Footer botones (igual estilo) */}
          <div className="text-right">
            <button type="submit" className="btn">
              Aplicar Filtros
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
